module.exports = __webpack_public_path__ + "img/altitude.6eb6a9a1.png";